import { Request } from '../request';

export type TTextVisitStateListParams = {
    state?: string;
    enabled?: boolean;
    pageNum: number;
    pageSize: number;
};

export type TTextVisitStateItem = {
    id?: number | string | null;
    state: string;
    enabled: boolean;
    sort?: number;
};

export const getTextVisitStatePageList = (params: TTextVisitStateListParams) =>
    Request.post({ url: '/admin-server/textVisitStateManagement/page', params });

export const saveOrUpdateTextVisitState = (params: TTextVisitStateItem) =>
    Request.post({ url: '/admin-server/textVisitStateManagement/saveOrUpdate', params });


